import { Action, ThunkAction, ThunkDispatch } from "@reduxjs/toolkit";

import { ReduxState, ThunkExtraArgument } from "@dashboard/types";

import { fetchDishes } from "./dishActions";
import { fetchLocations } from "./locationActions";
import { fetchMenus } from "./menuActions";
import { fetchProducts } from "./productActions";
import { fetchResolvedEdibles } from "./resolvedEdibleActions";
import { fetchSuppliers } from "./supplierActions";

export type InitialFetchThunkAction = ThunkAction<
  void,
  ReduxState,
  ThunkExtraArgument,
  Action
>;

export type InitialFetchThunkDispatch = ThunkDispatch<
  ReduxState,
  ThunkExtraArgument,
  Action
>;

// An action that fetches all the data needed to display
// most of the dashboard like menus, dishes, products, branding, analytics, etc.
export const initialFetchForReduxState: () => InitialFetchThunkAction = () => {
  return (dispatch: InitialFetchThunkDispatch) => {
    dispatch(fetchMenus());
    dispatch(fetchProducts());
    dispatch(fetchDishes());
    dispatch(fetchResolvedEdibles());
    dispatch(fetchLocations()); // This is needed to show the LocationsComponent inside the MenuDrawer.
    dispatch(fetchSuppliers()); // This is needed to show suppliers in ProductDrawer.
  };
};
